import { MovieClip, Sprite, TextFormat } from "../runtime";
import { blackBlock } from "./assets";
import {
  FONT_BODY,
  FONT_DISPLAY,
  TEXT_COLOURS,
  createTextField,
} from "./textStyle";

/**
 * The pause overlay: a semi-transparent cover with "PAUSED" and the quit hint.
 * It also latches the ESC press, so quitting only fires once per pause.
 */
export class PauseScreen extends MovieClip {
  private escapePressed = false;

  constructor() {
    super();
    const format = new TextFormat();
    const cover = new Sprite();
    cover.graphics.beginBitmapFill(new blackBlock());
    cover.graphics.drawRect(0, 0, 720, 480);
    cover.graphics.endFill();
    this.addChild(cover);
    format.align = "center";
    format.font = FONT_DISPLAY;
    format.color = TEXT_COLOURS.lightCyan;
    format.size = 28;
    createTextField(this, format, {
      width: 720,
      height: 100,
      y: 180,
      text: "PAUSED",
    });
    // defaultTextFormat clones, so the first field keeps its display font
    format.font = FONT_BODY;
    format.size = 18;
    createTextField(this, format, {
      width: 720,
      height: 100,
      y: 215,
      text: "Press ESC to quit this mission",
    });
  }

  /** True only for the first ESC of this pause. */
  pressEscape(): boolean {
    if (this.escapePressed) {
      return false;
    }
    this.escapePressed = true;
    return true;
  }
}
